module.exports = __webpack_public_path__ + "static/media/dash.17f637b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/climasense/xanthomonas_pimiento/curativa/dash.png
// module id = 1446
// module chunks = 3